import { QueryClient } from '@tanstack/react-query';

export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      retry: 0,
      staleTime: Infinity, 
      gcTime: Infinity,   
    },
    mutations: {
      gcTime: Infinity,  
    },
  },
});

// import { QueryClient } from "@tanstack/react-query";
// import { persistQueryClient } from "@tanstack/react-query-persist-client";
// import { createSyncStoragePersister } from "@tanstack/query-sync-storage-persister";

// export const queryClient = new QueryClient({
//   defaultOptions: {
//     queries: {
//       retry: 0,
//       // cacheTime: Infinity,   
//       // staleTime: Infinity, 
//       // refetchOnWindowFocus: false,
//     },
//   },
// });

// const localStoragePersister = createSyncStoragePersister({
//   storage: window.localStorage,
// });

// persistQueryClient({
//   queryClient,
//   persister: localStoragePersister,
//   maxAge: 1000 * 60 * 60 * 24 * 365 * 100,
// });


